module.exports = __webpack_public_path__ + "c0b631c876891d51991c019538421cf0.woff2";